<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
                <span translation="Axilla.Apps.Webshop.App.ConfirmOrder" source="AxillaAppWebshop"></span>
            </h3>
            <span class="kt-subheader__separator kt-subheader__separator--v"></span>
            <span class="kt-subheader__desc">
                <span translation="Axilla.Apps.Webshop.App.ConfirmOrderHeaderInfo" source="AxillaAppWebshop"></span>
            </span>
        </div>
    </div>
    <div class="kt-content">
        <div class="kt-portlet" style="width: -webkit-fill-available;">

            <div class="container-fluid d-flex align-items-center p-5 mb-5" style="text-align: center">
                <div>
                    <div class="wizard-progress">
                        <ng-container *ngFor="let step of steps">
                            <div [class]="'step ' + step.stepState">
                                <span>{{step.name}}</span>
                                <!--<span translation="{{step.translationLabel}}" source="AxillaAppBase"></span>-->
                                <div class="node"></div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="kt-content">

        <ng-container *ngIf="!loading">

            <ng-container *ngIf="stepName == 'BackorderStep'">
                <div class="kt-portlet" style="width: -webkit-fill-available;">


                    <div class="kt-portlet__body">

                        <strong align="center" style="font-size: 1.3em; color: var(--ubl-red, #ff7675) !important; ">
                            Some of your articles are not on stock. You have the possibility to create back order for not available articles. Our Customer Service department will contact you about the delivery dates.
                        </strong>

                        <div class="faq-container">
                            <h4>Backorder:</h4>
                            <ng-container *ngIf="checkOnlineHelperFeature()">
                                <helper bookmark="backorder"></helper>
                            </ng-container>
                        </div>

                        <p align="center" style="color: var(--ubl-green, #00b894); margin: 25px 0 15px; ">
                            These articles are not on stock and this back order will be placed on hold, to be delivered when stock is available. If you wish to cancel this back order, please delete the items.
                        </p>
                        <div class="order-guide-container relevant-articles">
                            <app-confirm-order-backorder style="flex: 1"></app-confirm-order-backorder>
                        </div>


                        <h4 style="margin: 50px 0 25px">Directly available:</h4>

                        <p align="center" style="color: var(--ubl-green, #00b894); margin: 25px 0 15px; ">
                            The following articles are available and will be processed directly after confirmation.
                        </p>
                        <div class="order-guide-container relevant-articles">
                            <app-confirm-order-backorder [showPallet]="true" style="flex: 1"></app-confirm-order-backorder>
                        </div>



                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="stepName == 'TransportStep' && confirmOrderData.delivery">
                <div class="kt-portlet" style="width: -webkit-fill-available;">


                    <div class="kt-portlet__body">

                        <p align="center">
                            Please select one of the types of transport:
                        </p>

                        <div class="order-guide-container relevant-articles">

                            <app-delivery-selector [multiple]="false"
                                                   [items]="confirmOrderData.delivery"
                                                   (selectDelivery)="selectDelivery($event)">
                            </app-delivery-selector>

                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="stepName == 'AdditionalArticlesStep'">
                <div class="kt-portlet" style="width: -webkit-fill-available;">
                    <p align="center">
                        We kindly request you to add the required documents for your custom clearance to your shopping basket:
                    </p>

                    <div class="additional-article-container relevant-articles">

                        <app-additional-article-selector style="flex: 1"
                                                         [multiple]="true"
                                                         [items]="confirmOrderData.articles"
                                                         (selectArticle)="selectDelivery($event)">
                        </app-additional-article-selector>

                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="stepName == 'AgreementStep'">
                <div class="kt-portlet" style="width: -webkit-fill-available;">
                    <p align="center">
                        Please agree to our terms and conditions.
                    </p>

                    <div class="additional-article-container relevant-articles">

                        <app-confirm-order-terms-and-conditions style="flex: 1"
                                                                [isRequired]="showIsRequired"
                                                                [agreements]="confirmOrderData.agreements"
                                                                (acceptAgreement)="acceptAgreement($event)">
                        </app-confirm-order-terms-and-conditions>

                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="stepName == 'SummaryStep'">
                <div class="kt-portlet" style="width: -webkit-fill-available;">
                    <app-confirm-order-summary style="flex: 1"></app-confirm-order-summary>
                </div>
            </ng-container>

            <ng-container *ngIf="stepName == 'PaymentStep'">
                <div class="kt-portlet" style="width: -webkit-fill-available;">
                    PaymentStep
                </div>
            </ng-container>

        </ng-container>

    </div>


    <div class="d-flex align-items-center justify-content-end">
        <button *ngIf="stepNumber > 0"
                (click)="goBack()"
                [disabled]="!isDisableToMoveBack()"
                type="button"
                class="btn btn-primary btn-elevate kt-login__btn-primary">
            <i class="fa fa-arrow-left"></i>
            {{"Previous" | localize}}
        </button>

        <button type="button"
                *ngIf="stepNumber < totalSteps"
                (click)="goNext()"
                class="btn btn-primary btn-elevate kt-login__btn-primary"
                [disabled]="showIsRequired || !validateDeliveryStep() || !isDisableToMoveNext()">
            {{"Next" | localize}} <i class="fa fa-arrow-right"></i>
        </button>

        <button *ngIf="stepNumber == totalSteps"
                type="button"
                class="btn btn-primary btn-elevate kt-login__btn-primary"
                (click)="confirmOrder()">
            <i class="fa fa-check"></i>
            Confirm
        </button>

    </div>
</div>
